module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/third-party.b1d223cb.svg";